import React from 'react'
import { dispatch } from '@rematch/core';
import { Button, Modal, Grid, Tab, Menu, Label, Message, Image, Icon } from 'semantic-ui-react'
import CommonTable from '../Table/TableLayout';
import contentHeader from './contentHeader.json'
import playbookHeader from './playbookHeader.json'
import initiativeHeader from './initiativeHeader.json'
class DeleteCategoryListModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            listData: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.content && this.props.catagoryAttachedDetails.content.data,
            tableHeader: contentHeader,
            total: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.content && this.props.catagoryAttachedDetails.total,
            _limit: 10,
            _sort: "createdAt"
        }
        this.deleteCategory = this.deleteCategory.bind(this);
    }

    componentWillMount() {
        this.localSetState(0)
    }


    handleClose = () => {
        dispatch.account.setDeleteCategoryModal(false);
    }


    async deleteCategory() {
        try {
            this.handleClose()
        }
        catch (error) {
        }
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex });
        this.localSetState(data.activeIndex)
    }

    localSetState = async (activeIndex) => {
        this.setState({ activeIndex: activeIndex })
        let tableHead;

        if (Number(activeIndex) === 0) {
            tableHead = contentHeader
            await dispatch.account.setSelectedAccountDataForContentManagement({query:{ "accountId": this.props.accountId, "organizationId": this.props.organizationId, "categoryType" : this.props.levelDepth, "categoryId" : this.props.actionSelectedCategory._id }})
            this.setState({
                listData: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.content && this.props.catagoryAttachedDetails.content.data,
                total: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.content && this.props.catagoryAttachedDetails.content.total,
                tableHeader: contentHeader
            })
        } else if (Number(activeIndex) === 1) {
            tableHead = playbookHeader
            await dispatch.account.setSelectedAccountDataForPlaybookManagement({query:{ "accountId": this.props.accountId, "organizationId": this.props.organizationId, "categoryType" : this.props.levelDepth, "categoryId" : this.props.actionSelectedCategory._id }})
            this.setState({
                listData: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.playbook,
                total: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.playbook && this.props.catagoryAttachedDetails.playbook.length,
                tableHeader: playbookHeader
            })
        } else if (Number(activeIndex) === 2) {
            tableHead = initiativeHeader
            await dispatch.account.setSelectedAccountDataForInitiativeManagement({query:{ "accountId": this.props.accountId, "organizationId": this.props.organizationId, "categoryType" : this.props.levelDepth, "categoryId" : this.props.actionSelectedCategory._id }})
            this.setState({
                listData: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.initiative && this.props.catagoryAttachedDetails.initiative.data,
                total: this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.initiative && this.props.catagoryAttachedDetails.initiative.total,
                tableHeader: initiativeHeader
            })
        } else {
            tableHead = contentHeader
        }

        if (this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length !== 0) {
            let user = []
            for (let i = 0; i < this.props.selectedAccount.users.length; i++) {
                let ia = this.props.selectedAccount.users[i]
                user.push({
                    value: ia.id._id,
                    text: ia.id.firstName + ' ' + ia.id.lastName,
                    content: (
                        <span>
                            <Image key={i} avatar className="w_24 h_24 scaleDown" src={ia.id.profilePic} />
                            {ia.id.firstName}  {ia.id.lastName}
                        </span>
                    ),
                })
            }
            tableHead[1].keyValue = user;
            this.setState({tableHeader : tableHead});
        }
    }

    render() {
        const { catagoryAttachedDetails, actionSelectedCategory, levelDepth, action } = this.props
        const { activeIndex, tableHeader, listData, total } = this.state;

        let table = <CommonTable
            tableHeader={tableHeader}
            listData={listData}
            searchable={false}
            limit={this.state._limit}
            sort={this.state._sort}
            selection={false}
            totalCount={listData && listData.length}
            activeIndex={activeIndex}
            filterHeader={true}
        />

        const panes = [
            {
                menuItem: <Menu.Item key='Content'>
                    Content <Label>{this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.content && this.props.catagoryAttachedDetails.content.total}</Label>
                </Menu.Item>, render: () => table
            }, {
                menuItem: <Menu.Item key='Playbook' >
                    Playbook <Label>{this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.playbook && this.props.catagoryAttachedDetails.playbook.length}</Label>
                </Menu.Item>, render: () => table
            }, {
                menuItem: <Menu.Item key='Playbook'  >
                    Initiative <Label>{this.props.catagoryAttachedDetails && this.props.catagoryAttachedDetails.initiative && this.props.catagoryAttachedDetails.initiative.total}</Label>
                </Menu.Item>, render: () => table
            },
        ]

        let header = action.name === "Delete" ? `Delete Category ( ${actionSelectedCategory.name} )` :
            action.name === "Usage" ? `${levelDepth === "baseCategory" ? "Knowledge Bank" : levelDepth === "category" ? "Category" : levelDepth === "subCategory" ? "Sub Category" : ""} Usage  ( ${actionSelectedCategory.name} )` : null
        return (
            <Modal
                open={this.props.open}
                onClose={this.handleClose}
                size='large'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >

                <Modal.Header>{header}</Modal.Header>
                <Modal.Content scrolling>
                    {action.name === "Delete" ?
                        <Message icon color='yellow'>
                            <Icon className="f_14" name='warning sign' />
                            <Message.Content> You can not delete this {levelDepth === "baseCategory" ? "Knowledge Bank" : levelDepth === "category" ? "Category" : levelDepth === "subCategory" ? "Sub Category" : ""} because it may have Content, Playbooks and Initiatives. </Message.Content>
                        </Message> : null}
                    <Tab
                        style={{ padding: 0 }}
                        menu={{ secondary: true, pointing: true }}
                        panes={panes}
                        activeIndex={activeIndex}
                        onTabChange={this.handleTabChange}
                        className="three-block" />
                </Modal.Content>
                <Modal.Actions className="actionInFormcy">
                    <Button
                        className="button-submit float-right"
                        id='deletebtn'
                        onClick={this.deleteCategory}> Got it
                      </Button>
                    <Button
                        id='cancelBtn'
                        className="button-cancel"
                        onClick={this.handleClose}> Cancel
                        </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default DeleteCategoryListModal